import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import {
  DASHBOARD_BLOCK_SET_DATA,
} from 'rebook/apps/dashboard/constants';


export const fetchInitialData = (match, nextPageQuery) => {
  return async(dispatch, getState) => {
    const { dashboardBlocks } = getState().dashboardBlockList;

    if (!dashboardBlocks || nextPageQuery) {
      await dispatch(fetchDashboardBlockList(match, nextPageQuery));
    }
  };
};

export const fetchDashboardBlockList = (match, nextPageQuery) => {
  return async(dispatch) => {
    const baseUrl = '/api/dashboard/';
    const url = nextPageQuery ? `${baseUrl}?${nextPageQuery}` : baseUrl;
    return fetchQuery(url, { apiVersion: 3 })
      .then(({ data }) => {
        dispatch(setData({ dashboardBlocks: data }));
        return dispatch;
      })
      .catch(({ data, resp }) => {
        Raven.captureMessage('failed to load dashboard page due to server error', {
          level: 'error',
          extra: {
            url: url,
            status: resp.status,
            response: data,
          },
        });
        return null;
      });
  };
};

export const fetchDashboardBlock = (url, options = {}) => {
  return async(dispatch) => {
    return fetchQuery(url, options)
      .then(({ data }) => {
        return { data, dispatch };
      })
      .catch(({ data, resp }) => {
        Raven.captureMessage('failed to fetch dashboard banner due to server error', {
          level: 'error',
          extra: {
            status: resp.status,
            response: data,
          },
        });
        return { data, resp };
      });
  };
};

export const setDashboardState = (state) => {
  return async(dispatch) => {
    return dispatch(setData({ dashboardState: state }));
  };
};

export const setData = (payload) => {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_BLOCK_SET_DATA,
      payload,
    });
  };
};

export const setSeoMeta = () => {
  return (dispatch) => {
    const title = 'Что почитать интересного? Подборки, которые помогут вам определиться, какую книгу почитать';
    const description = 'Не знаете, что почитать интересного? Не беда. ' +
                       'Каждый день мы готовим интересные и актуальные подборки со списками книг, ' +
                       'которые помогут вам определиться какую книгу почитать на одном дыхании';
    dispatch(SeoActions.setData({
      title: title,
      description: description,
    }));
  };
};
